import {CSkeleton} from "./CSkeleton";
import {CSkeletonDashboard} from "./CSkeletonDashboard";
import { CSkeletonTable } from "./CSkeletonTable";
import { CSkeletonPlan } from "./CSkeletonPlan";
import { CSkeletonNavList } from "./CSkeletonNavList";

export {
    CSkeleton,
    CSkeletonDashboard ,
    CSkeletonTable ,
    CSkeletonPlan ,
    CSkeletonNavList
}